import { useRuntime } from './useRuntime';

export const usePath = () => {
  const {
    page: { path },
  } = useRuntime();

  return {
    path,
    isHomepage: /^index\.?/.test(path),
    isRatgeberPage:
      path.startsWith('mietwagen-ratgeber') ||
      path.startsWith('guide-location-voiture'),
    isRatgeberAzPage:
      path.startsWith('mietwagen-ratgeber/a-z') ||
      path.startsWith('guide-location-voiture/a-z'),
    isRatgeberDestinationPage:
      /^mietwagen-ratgeber\/[^/]+\/reise-tipps/.test(path) ||
      /^mietwagen-ratgeber\/[^/]+\/reise-infos/.test(path),
    isMallorcaPage: path.startsWith('mietwagen-mallorca'),
  };
};
